var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaintbrush({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 56,
    viewBox: "0 0 49 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5 29.1459H36.5C38.0913 29.1459 39.6174 29.8702 40.7426 31.1595C41.8679 32.4488 42.5 34.1975 42.5 36.0209C42.5 37.8442 41.8679 39.5929 40.7426 40.8822C39.6174 42.1715 38.0913 42.8959 36.5 42.8959H34.5",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 49.7708C34.5 50.9864 34.0786 52.1522 33.3284 53.0117C32.5783 53.8713 31.5609 54.3542 30.5 54.3542H12.5C11.4391 54.3542 10.4217 53.8713 9.67157 53.0117C8.92143 52.1522 8.5 50.9864 8.5 49.7708V25.7083C8.5 25.4044 8.60536 25.113 8.79289 24.8981C8.98043 24.6832 9.23478 24.5625 9.5 24.5625H33.5C33.7652 24.5625 34.0196 24.6832 34.2071 24.8981C34.3946 25.113 34.5 25.4044 34.5 25.7083V49.7708Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.262 1.79248C36.328 5.39956 33.262 7.37727 32.556 9.31373C32.3682 9.76347 32.2653 10.2535 32.254 10.7519C32.2426 11.2503 32.3231 11.7458 32.4901 12.2061C32.6571 12.6665 32.9069 13.0813 33.2232 13.4236C33.5396 13.7659 33.9153 14.028 34.326 14.1927C40.126 17 41.854 3.89623 34.262 1.79248Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 24.5626L33.718 13.8215",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.782 14.6075L32.5 24.5625",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24.5625H10.5L7.5 17.6875L6.5 10.8125L11.5 14.25L16.5 24.5625Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 17.6875L11.5 14.25",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 2.79171C26.5 2.48781 26.3946 2.19637 26.2071 1.98148C26.0196 1.7666 25.7652 1.64587 25.5 1.64587H19.5C19.2348 1.64587 18.9804 1.7666 18.7929 1.98148C18.6054 2.19637 18.5 2.48781 18.5 2.79171V24.5625H26.5V2.79171Z",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 6.22925H22.5",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 10.8125H24.5",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 15.3959H22.5",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 19.9792H24.5",
    stroke: "#999999",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 55,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaintbrush);
export default __webpack_public_path__ + "static/media/paintbrush.28ba37e534e4bbe9a3cca0a201fdbb9b.svg";
export { ForwardRef as ReactComponent };